{
  "scripts": {
    "https://request.eprotect.vantivcnp.com/eProtect/eProtect-api3.js": "sha384-M2K+qvdoOf6J5Er7KbEcR/3yclnDy4E+BKKzPJGe5Px7Lc1gU5/EzOcggP0fdoCf",
    "https://request.eprotect.vantivprelive.com/eProtect/eProtect-api3.js": "sha384-VM96ZnWRJL1Ez7nVX13O5k0nAYPXEL56O5CZJgzmzo+UkXbnyQljUv07JTX9HiEf"
  }
}